import { SHARED_DATA_STATUS } from "@/domain/sharedData/constants"

// InterBU status palette of the design system (dist/css/interbu-status.css, ADR 0009 revised on
// 2026-10-06). Not part of the brand palette: the DS scopes it to the InterBU screens, so it lives
// here and is imported by InterBU components only, never by the theme.
// fill: dots, bars, keys, rules · ink: text (4.5:1 on white and on tint) · tint: soft badge ground.
export type InterBuStatusColors = { fill: string; ink: string; tint: string }

export type InterBuPaletteStatus =
  | "pending"
  | "accepted"
  | "in-progress"
  | "finalised"
  | "denied"
  | "revoked"
  | "cancelled"
  | "closed"

export const INTERBU_PALETTE: Record<InterBuPaletteStatus, InterBuStatusColors> = {
  pending: { fill: "#E2A72E", ink: "#7A5200", tint: "#FBF0D6" },
  accepted: { fill: "#2F6FD0", ink: "#1F4F9E", tint: "#E4ECF9" },
  "in-progress": { fill: "#129C94", ink: "#0B6560", tint: "#DCF1EE" },
  finalised: { fill: "#1E9A5B", ink: "#146B3E", tint: "#DEF1E5" },
  denied: { fill: "#C4462B", ink: "#9B321C", tint: "#F9E3DD" },
  revoked: { fill: "#8C55A8", ink: "#693A84", tint: "#F0E6F5" },
  cancelled: { fill: "#A0957F", ink: "#5C5444", tint: "#EFECE5" },
  closed: { fill: "#1A1A1A", ink: "#1A1A1A", tint: "#EAE6DD" },
}

// Status of a share → colour of the DS. "accepted" is shown as "In progress", hence the
// in-progress colour; the DS "accepted" colour is the "Accepted" step of the timeline.
const PALETTE_OF_STATUS: Record<string, InterBuPaletteStatus> = {
  [SHARED_DATA_STATUS.ASKED]: "pending",
  [SHARED_DATA_STATUS.ACCEPTED]: "in-progress",
  [SHARED_DATA_STATUS.COMPLETED]: "finalised",
  [SHARED_DATA_STATUS.DENIED]: "denied",
  [SHARED_DATA_STATUS.REVOKED]: "revoked",
  [SHARED_DATA_STATUS.CANCELLED]: "cancelled",
  [SHARED_DATA_STATUS.CLOSED]: "closed",
}

// Colours of a share status; undefined for a status the DS does not colour (archive).
export const getInterBuStatusColors = (status?: string): InterBuStatusColors | undefined => {
  const paletteStatus = status ? PALETTE_OF_STATUS[status] : undefined
  return paletteStatus && INTERBU_PALETTE[paletteStatus]
}

// Steps of the card timeline: sent, accepted, completed.
export const TIMELINE_STEP_COLORS: Record<string, InterBuStatusColors> = {
  sent: INTERBU_PALETTE.pending,
  accepted: INTERBU_PALETTE.accepted,
  completed: INTERBU_PALETTE.finalised,
}
